/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyDailyNavConfigComp } from './CompanyDailyNavConfigComp';
import type { FirmDailyNavConfigVersion } from './FirmDailyNavConfigVersion';
export type CompanyDailyNavConfigVersion = {
  readonly id?: number;
  company: number;
  firm_config_version?: FirmDailyNavConfigVersion;
  effective_from: string;
  effective_to?: string | null;
  cap_iq_short_window_delta?: string | null;
  cap_iq_long_window_delta?: string | null;
  cap_iq_since_last_valuation_delta?: string | null;
  secondary_short_window_delta?: string | null;
  secondary_long_window_delta?: string | null;
  secondary_since_last_valuation_delta?: string | null;
  secondary_change_from_mark_delta?: string | null;
  change_trigger: CompanyDailyNavConfigVersion.change_trigger;
  /**
   * Alexandria company profile this company's Daily NAV data is pulled from. Snapshotted onto the version, like comps. Null = not linked.
   */
  alexandria_id?: string | null;
  readonly comps?: Array<CompanyDailyNavConfigComp>;
  readonly created_by_name?: string;
  readonly is_active?: boolean;
  readonly created_at?: string;
};
export namespace CompanyDailyNavConfigVersion {
  export enum change_trigger {
    FIRM_TEMPLATE_CHANGE = 'firm_template_change',
    COMPANY_EDIT = 'company_edit',
  }
}

